//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import {
  CATALOG_COUNTRY_CODES,
  CATALOG_LANGUAGE_CODES,
} from '@apis/catalog-validation/catalogValidationModel';
import { CATALOG_LOCALE_TYPES } from '@catalog-ingestion/constants/connectPanelConstants';

export const parseLocale = (selectedLocale: CATALOG_LOCALE_TYPES) => {
  let [languageCode, countryCode] = selectedLocale.split('-');

  languageCode = languageCode?.toLowerCase();
  countryCode = countryCode?.toUpperCase();

  return {
    languageCode: languageCode as unknown as CATALOG_LANGUAGE_CODES,
    countryCode: countryCode as unknown as CATALOG_COUNTRY_CODES,
  };
};
